import { useState } from "react";
import { CartProvider } from "@/context/CartContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Manifesto from "@/components/Manifesto";
import BeforeAfter from "@/components/BeforeAfter";
import Catalog from "@/components/Catalog";
import Glp1Program from "@/components/Glp1Program";
import Wholesale from "@/components/Wholesale";
import Footer from "@/components/Footer";
import IntakeModal from "@/components/IntakeModal";
import CartDrawer from "@/components/CartDrawer";

export default function Landing() {
  const [intakeOpen, setIntakeOpen] = useState(false);
  const openConsult = () => setIntakeOpen(true);

  return (
    <CartProvider>
      <SmoothScroll>
        <div className="App grain">
          <Navbar onConsult={openConsult} />
          <main>
            <Hero onConsult={openConsult} />
            <Manifesto />
            <BeforeAfter />
            <Glp1Program />
            <Catalog />
            <Wholesale />
          </main>
          <Footer onConsult={openConsult} />
        </div>
        <IntakeModal open={intakeOpen} onClose={() => setIntakeOpen(false)} />
        <CartDrawer />
      </SmoothScroll>
    </CartProvider>
  );
}
